import type { FC } from 'react';
import { Popper } from '../Popper';
import * as Styled from './styled';
import type { ActionsPopperProps } from './types';

export * from './types';

export const ActionsPopper: FC<ActionsPopperProps> = (props) => {
  const { items, popper } = props;
  return (
    <Popper {...popper}>
      <Styled.Wrapper>
        {items.map((item, index) => (
          <Styled.ItemWrapper key={index} onClick={item.onClick}>
            <Styled.ItemIconWrapper>
              {item.iconName && <Styled.ItemIcon icon={item.iconName} />}
              {item.iconElement}
            </Styled.ItemIconWrapper>
            <Styled.ItemText>{item.label}</Styled.ItemText>
          </Styled.ItemWrapper>
        ))}
      </Styled.Wrapper>
    </Popper>
  );
};
